// extracted by mini-css-extract-plugin
module.exports = {"layout":"AuthLayout_layout__2cygI","header":"AuthLayout_header__3JW83","content":"AuthLayout_content__j6oDT","logo":"AuthLayout_logo__YhbwH"};